<template>
  <div class="comment position-relative d-flex gap-3">
    <!-- <eg-colored-dot-box
      :color="commentColor"
      :background-color="commentBackgroundColor"
    /> -->
    <div class="w-100">
      <div class="title">
        <div class="name">
          {{ comment.author.firstName }} {{ comment.author.lastName }}
        </div>
        <div>{{ date }}</div>
      </div>

      <div v-if="isEdit" class="text mt-2">
        <eg-b-form-textarea
          v-model="newCommentText"
          :placeholder="$t('essays.enterAnalysis')"
          rows="2"
          max-rows="4"
        />
      </div>
      <div v-else class="text mt-2">{{ comment.text }}</div>

      <div v-if="!isEdit" class="d-flex mt-2">
        <eg-button
          type="secondary"
          size="sm"
          icon="pen-edit"
          class="ml-auto mr-2"
          @click="
            () => {
              isEdit = true;
              newCommentText = comment.text;
            }
          "
        >
          Edit
        </eg-button>
        <eg-button
          size="sm"
          type="secondary"
          icon="delete"
          @click="$emit('delete', comment)"
        >
          Delete
        </eg-button>
      </div>
      <div v-else class="d-flex mt-2">
        <eg-button
          type="secondary"
          size="sm"
          class="ml-auto mr-2"
          @click="isEdit = false"
        >
          Cancel
        </eg-button>
        <eg-button
          size="sm"
          type="primary"
          @click="
            () => {
              isEdit = false;
              $emit('update', { commentId: comment.id, text: newCommentText });
            }
          "
        >
          Save
        </eg-button>
      </div>
    </div>
  </div>
</template>

<script>
// TODO: this and ./tab_comment.vue unify by mixin logic
import formatDate from "@/utils/formatDate";
// import EgColoredDotBox from "@/components/global/eg/eg_colored_dot_box.vue";
import EgButton from "@/components/global/eg/buttons/eg_button.vue";

export default {
  components: {
    // EgColoredDotBox,
    EgButton,
  },
  props: {
    comment: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      newCommentText: this.comment.text || "",
      isEdit: false,
    };
  },

  computed: {
    date() {
      return formatDate(this.comment.createdAt);
    },

    // commentColor() {
    //   // Use CSS custom property for central color
    //   return this.comment.color || "var(--color-surface-secondary-default)";
    // },

    // commentBackgroundColor() {
    //   // Use CSS custom property for background color
    //   return (
    //     this.comment.backgroundColor || "var(--color-surface-secondary-light)"
    //   );
    // },
  },
};
</script>

<style lang="scss" scoped>
.title {
  color: var(--Text-Secondary, #6c757d);
  font-family: Inter;
  font-size: 10px;
  font-weight: 400;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--color-stroke-neutral-default, #dfdfdf);

  .name {
    font-weight: 700;
  }
}

.text {
  color: var(--Text-Body, #212529);
  font-family: Inter;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;

  textarea {
    overflow-y: auto !important;
  }
}
</style>
